import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import PluginLayoutView from './PluginLayoutView';

export class PluginLayoutContainer extends Component {
  render() {
    return (
      <PluginLayoutView {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

export default withRouter(connect(mapStateToProps)(PluginLayoutContainer));



// WEBPACK FOOTER //
// ./src/app/layouts/plugin/PluginLayoutContainer.js